import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { ToastContainer, toast } from "react-toastify";
import "sweetalert2/src/sweetalert2.scss";
import moment from "moment";
import {
    getRequest,
    postRequest,
    deleteRequest,
    putRequest,
    postRequestForm,
    deleteConfirmationWords,
} from "components/Common/Utils";

import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
    SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";

import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Spinner,
    Badge,
    Button,
} from "reactstrap";
import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";

const NotificationsDetails = (props) => {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [totalNotifications, setTotalNotifications] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(1000);
    const [sortOrder, setSortOrder] = useState("order");
    const [searchText, setSearchText] = useState("");
    const history = useHistory();

    useEffect(() => {
        fetchNotifications();
    }, [currentPage, pageSize, sortOrder]);

    const fetchNotifications = async () => {
        try {
            setLoading(true);
            setError(null);

            const payload = {
                page: currentPage,
                limit: pageSize,
                type: sortOrder,
                search: searchText,
                sortField: "createdAt",
                sortOrder: "desc",
            };

            const response = await postRequest("notification/admin-list", payload);

            if (response.status && response.data) {
                const sortedNotifications = (response.data.notifications || []).sort(
                    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                );
                setNotifications(sortedNotifications);
                setTotalNotifications(response.data.total || 0);
            } else {
                throw new Error(response.message || "Failed to load notifications");
            }
        } catch (err) {
            setError(err.message || "Failed to load notifications");
        } finally {
            setLoading(false);
        }
    };

    const handleNotificationClick = async (notification) => {
        try {
            if (!notification.readStatus) {
                await postRequest(`/notification/admin-read`, {
                    notificationId: notification._id,
                });
                setNotifications(
                    notifications.map((n) =>
                        n._id === notification._id ? { ...n, readStatus: true } : n
                    )
                );
            }

            if (notification.type === "order" && notification.typeId) {
                history.push(`/user-order-details/${notification.typeId}`);
            } else if (
                notification.type === "manufacture-order" &&
                notification.typeId
            ) {
                history.push(`/order-sent-manufacturer/${notification.typeId}`);
            }
        } catch (err) {
            console.error("Error handling notification click:", err);
        }
    };

    function DateFormatter(cellContent, row) {
        return (
            <div className="d-flex gap-2 align-items-center">
                {moment(row?.createdAt).format("DD-MM-YYYY hh:mm")}
            </div>
        );
    }

    function SNoFormatter(cellContent, row, i) {
        return <>{i + 1}</>;
    }

    const columns = [
        {
            text: "S.NO",
            formatter: SNoFormatter,
            sort: false,
        },
        {
            dataField: "type",
            text: "Type",
            sort: false,
        },
        {
            dataField: "title",
            text: "Title",
            sort: false,
        },
        {
            dataField: "description",
            text: "Description",
            sort: false,
        },
        {
            formatter: DateFormatter,
            text: "Created At",
            sort: false,
        },
    ];

    const handleTableChange = (
        type,
        { page, sizePerPage, sortField, sortOrder }
    ) => {
        if (type === "pagination") {
            if (page !== currentPage) {
                setCurrentPage(page);
            }
            if (sizePerPage !== pageSize) {
                setPageSize(sizePerPage);
            }
        }
    };

    const handleSearch = () => {
        setCurrentPage(1);
        fetchNotifications();
    };

    const handleReset = () => {
        setSearchText("");
        setCurrentPage(1);
        fetchNotifications();
    };

    return (
        <React.Fragment>
            <ToastContainer />
            <Row>
                <div className="col-md-6">
                    <div className="page-title-box">
                        <h4>Notification Details</h4>
                        <ol className="breadcrumb m-0">
                            <li className="breadcrumb-item active">Notification Details</li>
                            <li className="breadcrumb-item">Notification List</li>
                        </ol>
                    </div>
                </div>

                <Col className="col-12">
                    <Card>
                        {loading ? (
                            <CardBody style={{ height: "100px" }}>
                                <Spinner
                                    color="info"
                                    style={{
                                        height: "4rem",
                                        width: "4rem",
                                        position: "absolute",
                                        left: "50%",
                                    }}
                                >
                                    Loading...
                                </Spinner>
                            </CardBody>
                        ) : (
                            <CardBody className="table-shorting">
                                <PaginationProvider
                                    pagination={paginationFactory({
                                        page: currentPage,
                                        sizePerPage: pageSize,
                                        totalSize: totalNotifications,
                                        custom: true,
                                    })}
                                >
                                    {({ paginationProps, paginationTableProps }) => (
                                        <>
                                            <ToolkitProvider
                                                keyField="_id"
                                                data={notifications}
                                                columns={columns}
                                                search
                                            >
                                                {(props) => (
                                                    <Row>
                                                        <Col className="col-lg-12 d-flex mb-3">
                                                            {/* <label className="mb-0 text-label">
                                                                Page Size
                                                            </label>
                                                            <select
                                                                value={pageSize}
                                                                onChange={(e) => setPageSize(Number(e.target.value))}
                                                                className="form-select"
                                                                style={{ width: "7%" }}
                                                            >
                                                                <option value="10">10</option>
                                                                <option value="20">20</option>
                                                                <option value="50">50</option>
                                                            </select> */}

                                                            <label className="mb-0 text-label ms-3">
                                                                Filter Order:
                                                            </label>
                                                            <select
                                                                value={sortOrder}
                                                                onChange={(e) => setSortOrder(e.target.value)}
                                                                className="form-select"
                                                                style={{ width: "10%" }}
                                                            >
                                                                <option value="order">Order</option>
                                                                <option value="manufacture-order">
                                                                    Manufacture Order
                                                                </option>
                                                            </select>

                                                            <div
                                                                className="filter-item"
                                                                style={{ width: "86.5%" }}
                                                            >
                                                                <input
                                                                    type="search"
                                                                    placeholder="Search"
                                                                    value={searchText}
                                                                    className="form-control"
                                                                    onChange={(e) =>
                                                                        setSearchText(e.target.value)
                                                                    }
                                                                    style={{ width: "30%" }}
                                                                />
                                                                <button
                                                                    onClick={handleSearch}
                                                                    type="button"
                                                                    className="btn btn-primary mx-2"
                                                                >
                                                                    Search
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    onClick={handleReset}
                                                                    className="btn btn-danger mx-2"
                                                                >
                                                                    Reset
                                                                </button>
                                                            </div>
                                                        </Col>

                                                        <Col className="col-lg-12 text-end">
                                                            <BootstrapTable
                                                                {...props.baseProps}
                                                                {...paginationTableProps}
                                                                onTableChange={handleTableChange}
                                                                remote
                                                                classes="table-striped"
                                                                rowEvents={{
                                                                    onClick: (e, row) => {
                                                                        handleNotificationClick(row);
                                                                    },
                                                                }}
                                                                rowStyle={(row) => ({
                                                                    backgroundColor: !row.readStatus
                                                                        ? "#f8f9fa"
                                                                        : "transparent",
                                                                    cursor: "pointer",
                                                                })}
                                                            />
                                                        </Col>
                                                    </Row>
                                                )}
                                            </ToolkitProvider>

                                            {/* <Row>
                        <Col className="col-lg-12 text-end">
                          <div className="text-md-right">
                            <PaginationListStandalone
                              {...paginationProps}
                            />
                          </div>
                        </Col>
                      </Row> */}
                                        </>
                                    )}
                                </PaginationProvider>
                            </CardBody>
                        )}
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default NotificationsDetails;
